import { useAppSelector } from '@/hooks/useAppSelector';

import { selectSecurityAuditLeaksReports } from '../services/selectors';

export const useSecurityAuditLeaksReports = () => useAppSelector(selectSecurityAuditLeaksReports);
